import React from 'react'
import { Col, Row } from 'react-bootstrap'
import NumberFormat from 'react-number-format'
import config from '../../config/constant'
import { VIEW_DETAILS_COMMON_KEYS, VIEW_TD_DETAILS_KEYS } from '../../utils/translation-constants'
import { useTranslation } from 'react-i18next'

export default function PaymentDetails({ option = {} }) {
  const { t } = useTranslation()
  return (
    <Row xs={12}>
      <Col className='col' xs={'6'} sm={'6'} md={'6'}>
        <label>{t(VIEW_TD_DETAILS_KEYS.AMOUNT)}</label>
        <span>
          <NumberFormat
            value={option?.payInAmt}
            displayType={'text'}
            thousandSeparator={true}
            prefix={''}
            fixedDecimalScale={true}
            decimalScale={2}
            allowEmptyFormatting
          />
        </span>
        <label>{t(VIEW_TD_DETAILS_KEYS.CURRENT_LEVEL)}</label>
        <span>{option?.currentLevel || '-'}</span>
        <label>{t(VIEW_DETAILS_COMMON_KEYS.INITIATED_BY)}</label>
        <span>{option?.initBy || '-'}</span>
        <label>{t(VIEW_DETAILS_COMMON_KEYS.INITIATED_DATE)}</label>
        <span>{option?.initDate !== null ? option?.initDate : '-'}</span>
        <label>{t(VIEW_TD_DETAILS_KEYS.INTERST_OF_CREDIT)}</label>
        <span>{option?.interestCredit || '-'}</span>
        <label>{t(VIEW_TD_DETAILS_KEYS.BRANCH_CODE)}</label>
        <span>{option?.branchCode || '-'}</span>
        <label>{t(VIEW_TD_DETAILS_KEYS.CUSTOMER_ID)}</label>
        <span>{option?.customerId || '-'}</span>
        <label>{t(VIEW_TD_DETAILS_KEYS.PRODUCT)}</label>
        <span>{option?.product || '-'}</span>
        <label>{t(VIEW_TD_DETAILS_KEYS.DAYS)}</label>
        <span>{option?.days || '-'}</span>
        <label>{t(VIEW_TD_DETAILS_KEYS.MONTHS)}</label>
        <span>{option?.months || '-'}</span>
      </Col>
      <Col className='col' xs={'6'} sm={'6'} md={'6'}>
        <label>{t(VIEW_TD_DETAILS_KEYS.YEARS)}</label>
        <span>{option?.years || '-'}</span>
        <label>{t(VIEW_TD_DETAILS_KEYS.CREDIT_ACCOUNT)}</label>
        <span>{option?.creditAccNo || '-'}</span>
        <label>{t(VIEW_TD_DETAILS_KEYS.CREDIT_ACCOUNT_BRANCH)}</label>
        <span>{option?.creditAccBrn || '-'}</span>
        <label>{t(VIEW_TD_DETAILS_KEYS.SOURCE_ACCOUNT_NO)}</label>
        <span>{option?.debitAccNo || '-'}</span>
        <label>{t(VIEW_TD_DETAILS_KEYS.SOURCE_BRANCH)}</label>
        <span>{option?.debitAccBrn || '-'}</span>
        <label>{t(VIEW_TD_DETAILS_KEYS.CURRENCY)}</label>
        <span>{option?.currency || '-'}</span>

        <label>{t(VIEW_DETAILS_COMMON_KEYS.AUTHORIZED_DATE)}</label>
        <span>{option?.authDate !== null ? option?.authDate : '-'}</span>
        <label>{t(VIEW_DETAILS_COMMON_KEYS.AUTHORIZED_STATUS)}</label>
        <span>
          {option?.authStatus === 'P'
            ? 'Pending'
            : option?.authStatus === 'A'
            ? 'Approved'
            : 'Rejected'}
        </span>
        <label>{t(VIEW_DETAILS_COMMON_KEYS.COMMENTS)}</label>
        <span>{option?.authorizerComments || '-'}</span>
      </Col>
    </Row>
  )
}
